import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import './Filter.css';

export class Filter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            languages: [],
            technology: []
        };
    }
    render() {
        let baseClass = "filter-container";
        if (this.props.isVisible) {
            baseClass += " visible";
        }
        return (
            <div className={baseClass}>
                <div className="filter-sidebar">
                    <div className="button-controls">
                        <div className="close-button" onClick={() => this.props.closeFilter()}></div>
                    </div>
                    <a className="clear-all" onClick={() => this.clearAll()}><span></span> Clear All </a>
                    <div className="filter-section">
                        <h5>Technology</h5>
                        <ul>
                            <li>
                                {this.buildFilterSection('technology', this.props.availableTechnology)}
                            </li>
                        </ul>
                    </div>

                    <div className="filter-section">
                        <h5>Languages</h5>
                        <ul>
                            <li>
                                {this.buildFilterSection('languages', this.props.availableLanguages)}
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="body-overlay" />
            </div>
        );
    }
    buildFilterSection(category, items) {
        return _.map(items, (item, idx) => {
            const displayName = item /*.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');*/
            return (
                <div key={idx}>
                    <label>
                        <input
                            type="checkbox"
                            name={category}
                            value={item}
                            checked={_.includes(this.state[category], item)}
                            onChange={(e) => this.applyFilter(e)} />
                        {displayName}
                    </label>
                    <br />
                </div>
            );
        });
    }
    applyFilter(e) {
        const obj = _.cloneDeep(this.state);
        const category = e.target.name;
        const value = e.target.value;
        if (e.target.checked) {
            obj[category].push(value);
        } else {
            obj[category] = _.remove(this.state[category], (item) => {
                return item !== value; // this reads weird but we want to return the items that do not match the selected value
            });
        }
        this.setState(obj);
        this.props.onChange(obj);
    }
    clearAll() {
        const obj = {
            languages: [],
            technology: []
        };
        this.setState(obj)
        this.props.onChange(obj);
    }
}

Filter.propTypes = {
    isVisible: PropTypes.bool,
    onChange: PropTypes.func,
    availableLanguages: PropTypes.array,
    availableTechnology: PropTypes.array,
    closeFilter: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/Filter.js